export default {
  'component.myorders.title': 'Dine meglertjenester',
  'component.myorders.description': 'Her finner du oversikten over tjenestene som selges bestilt',
};
